import React, { useState, useEffect } from "react";
import "./AuctionProductCard.css";

const AuctionProductCard = ({
  product,
  onBid,
  onAddToCart,
  reloadProducts,
}) => {
  const [bidAmount, setBidAmount] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [loadingCart, setLoadingCart] = useState(false);
  const [alert, setAlert] = useState(null);
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    const updateTimer = () => {
      const now = new Date();
      const end = new Date(product.auction_end_date);
      const diff = end - now;

      if (diff <= 0) {
        setTimeLeft("Auction ended");
      } else {
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / 1000 / 60) % 60);
        const seconds = Math.floor((diff / 1000) % 60);

        const formatted = `${days}d ${hours}h ${minutes}m ${seconds}s`;
        setTimeLeft(formatted);
      }
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [product.auction_end_date]);

  const handleBidClick = async () => {
    try {
      setSubmitting(true);
      const response = await onBid(product._id, Number(bidAmount));

      if (response?.status === "success") {
        setBidAmount("");
        setAlert({
          type: "success",
          message: response.message || "Bid placed!",
        });
        setTimeout(() => {
          reloadProducts?.();
        }, 3000);
      } else {
        setAlert({ type: "error", message: response?.message || "Bid failed" });
      }
    } catch (error) {
      setAlert({ type: "error", message: error?.message || "Bid failed" });
    } finally {
      setSubmitting(false);
    }
  };

  const handleCartClick = async () => {
    try {
      setLoadingCart(true);
      const response = await onAddToCart(product._id);
      if (response.status === 200) {
        setAlert({ type: "success", message: "Added to cart" });
      } else {
        setAlert({ type: "error", message: response?.message || "Bid failed" });
      }
    } catch (error) {
      const message =
        error?.response?.data?.message || // most likely case
        error?.message ||
        "Add to cart failed";

      setAlert({ type: "error", message });
    } finally {
      setLoadingCart(false);
    }
  };

  return (
    <div className="auction-card">
      {alert && (
        <div className={`alert-fixed ${alert.type}`}>
          {alert.message}
          <button onClick={() => setAlert(null)}>×</button>
        </div>
      )}

      <div className="auction-gallery">
        {product.gallery.map((img) => (
          <img key={img._id} src={img.original} alt={product.name} />
        ))}
      </div>

      {product.video && (
        <video className="auction-video" src={product.video} controls />
      )}

      <div className="auction-info">
        <h3>{product.name}</h3>
        <p>{product.description}</p>
        <p>⏱ Time Left: {timeLeft}</p>
        <p>🟡 Start Bid: ₦{product.auction_starting_bid}</p>
        <p>📈 Current Bid: ₦{product.auction_highest_bid}</p>

        <input
          type="number"
          value={bidAmount}
          onChange={(e) => setBidAmount(e.target.value)}
          placeholder="Enter your bid"
        />
        <button onClick={handleBidClick} disabled={submitting}>
          {submitting ? "Placing..." : "Place Bid"}
        </button>

        <button onClick={handleCartClick} disabled={loadingCart}>
          {loadingCart ? "Adding..." : "Add to Cart"}
        </button>
      </div>
    </div>
  );
};

export default AuctionProductCard;
